import { Grid } from "@mui/material"
import { FC, ReactNode } from "react"

export const TableGrid: FC<{children: ReactNode, minWidth?: number}> = ({children, minWidth = 1}) => {
    // Here sx has value of 6 because in very smaller screens also we can show 2 input fields at one line. If we need to change this we can set this to 12 for xs.
    return <Grid justifyContent="center" item xs={Math.max(minWidth, 2)} sm={2} md={1} lg={1} padding={1}>
        {children}
    </Grid>
}